import { VENUE } from '@constants/buzzkuri/program-detail'
import React, { useMemo } from 'react'
import { ProgramRequestOfferContent } from './Content'
import { ProgramRequestOfferDescription } from './Description'
import { ProgramRequestOfferDivide } from './Divide'
import { ProgramRequestOfferFotterBtn } from './FotterBtn'
import { ProgramRequestOfferHeading } from './Heading'

type Props = {
  requiredTime: number
  venue: string
  id: number
  programId: number
}

export const ProgramRequestOffer = ({
  requiredTime,
  venue,
  id,
  programId,
}: Props): JSX.Element => {
  const items = useMemo(
    () => [
      { label: '所要時間', value: `${requiredTime}分` },
      { label: '会場', value: VENUE[venue] ?? '' },
    ],
    [requiredTime, venue]
  )

  return (
    <div className="flex flex-col md:w-[24.6vw] shadow-20px">
      <div className="flex flex-col p-[2.6vw] rounded-tl-[20px]">
        <ProgramRequestOfferHeading />
        <div className="md:mt-[2.3vw]">
          <ProgramRequestOfferDescription />
        </div>
        <ProgramRequestOfferDivide />
        <div className="md:mt-[2.1vw]">
          <ProgramRequestOfferContent {...{ items }} />
        </div>
      </div>
      <div>
        <ProgramRequestOfferFotterBtn {...{ id, programId }} />
      </div>
    </div>
  )
}
